import { default as academyBGRCYtxklWMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/about/academy.vue?macro=true";
import { default as awardsqaZjDyMWuEMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/about/awards.vue?macro=true";
import { default as certificationsf5A2acsZHcMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/about/certifications.vue?macro=true";
import { default as heritageoQv1JjqU1nMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/about/heritage.vue?macro=true";
import { default as indexMBx3sR8imrMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/about/index.vue?macro=true";
import { default as our_45group7SMqHZKn4YMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/about/our-group.vue?macro=true";
import { default as partnersGPexttgVJLMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/about/partners.vue?macro=true";
import { default as sustainability9nrTUcJYF9Meta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/about/sustainability.vue?macro=true";
import { default as teamKPxY4WTxzGMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/about/team.vue?macro=true";
import { default as visit_45pininfarinaqpKPmttdKBMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/about/visit-pininfarina.vue?macro=true";
import { default as index6aIGjy6gaaMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/approach/index.vue?macro=true";
import { default as methodologygMqDa6ek4TMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/approach/methodology.vue?macro=true";
import { default as _91jobSlug_930MbZ3FBQAaMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/careers/[jobSlug].vue?macro=true";
import { default as indexv3HDHsi6PfMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/careers/index.vue?macro=true";
import { default as indexB3mM5oiVA2Meta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/classiche/index.vue?macro=true";
import { default as _91countrySlug_93edvwhUqYNhMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/[countrySlug].vue?macro=true";
import { default as indexzIC5OMk8F4Meta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/index.vue?macro=true";
import { default as messageSentDPKZeEVKfMMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/messageSent.vue?macro=true";
import { default as our_45officesaBOlLiagr0Meta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/our-offices.vue?macro=true";
import { default as cookie_45policyrLf6xOLSIfMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/cookie-policy.vue?macro=true";
import { default as index1U7rvuFukXMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/index.vue?macro=true";
import { default as indextIxeaogzOUMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/investor-relations/[[investorSlug]]/index.vue?macro=true";
import { default as hq_45resourcesy4dWnZnZAsMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/hq-resources.vue?macro=true";
import { default as indexiF9juaW9yeMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/index.vue?macro=true";
import { default as loginnpSGPqGqsWMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/login.vue?macro=true";
import { default as _91newsSlug_93cJVf2LgkEMMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/news/[newsSlug].vue?macro=true";
import { default as indexYNUcRNvDcqMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/news/index.vue?macro=true";
import { default as successQvKQtrfq78Meta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/pardot/success.vue?macro=true";
import { default as privacy_45policyFHW5fyzIyIMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/privacy-policy.vue?macro=true";
import { default as _91projectSlug_93MH0lUrzJElMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/projects/[projectSlug].vue?macro=true";
import { default as indexwXmi4oFwK3Meta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/projects/index.vue?macro=true";
import { default as indexGrsIIyHQ1LMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/search/index.vue?macro=true";
import { default as indexyI1RtRHRMeMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/[sectorSlug]/index.vue?macro=true";
import { default as portfolioNcqfFg8NHxMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/[sectorSlug]/portfolio.vue?macro=true";
import { default as index7uxvHB9tBdMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/index.vue?macro=true";
import { default as _91serviceSlug_93piRIjeJxAzMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/services/[serviceSlug].vue?macro=true";
import { default as indexb3TtlJztXqMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/services/index.vue?macro=true";
import { default as indexh1GmYsLMjyMeta } from "/home/forge/pininfarina.it/releases/20250625182455/pages/whistleblowing/index.vue?macro=true";
import { default as pininfarinaz5JivmXIxaMeta } from "/home/forge/pininfarina.it/releases/20250625182455/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
export default [
  {
    name: academyBGRCYtxklWMeta?.name ?? "about-academy___de",
    path: academyBGRCYtxklWMeta?.path ?? "/de/um/pininfarina-academy",
    meta: academyBGRCYtxklWMeta || {},
    alias: academyBGRCYtxklWMeta?.alias || [],
    redirect: academyBGRCYtxklWMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/academy.vue").then(m => m.default || m)
  },
  {
    name: academyBGRCYtxklWMeta?.name ?? "about-academy___en___default",
    path: academyBGRCYtxklWMeta?.path ?? "/about/pininfarina-academy",
    meta: academyBGRCYtxklWMeta || {},
    alias: academyBGRCYtxklWMeta?.alias || [],
    redirect: academyBGRCYtxklWMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/academy.vue").then(m => m.default || m)
  },
  {
    name: academyBGRCYtxklWMeta?.name ?? "about-academy___en",
    path: academyBGRCYtxklWMeta?.path ?? "/en/about/pininfarina-academy",
    meta: academyBGRCYtxklWMeta || {},
    alias: academyBGRCYtxklWMeta?.alias || [],
    redirect: academyBGRCYtxklWMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/academy.vue").then(m => m.default || m)
  },
  {
    name: academyBGRCYtxklWMeta?.name ?? "about-academy___it",
    path: academyBGRCYtxklWMeta?.path ?? "/it/about/pininfarina-academy",
    meta: academyBGRCYtxklWMeta || {},
    alias: academyBGRCYtxklWMeta?.alias || [],
    redirect: academyBGRCYtxklWMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/academy.vue").then(m => m.default || m)
  },
  {
    name: academyBGRCYtxklWMeta?.name ?? "about-academy___zh",
    path: academyBGRCYtxklWMeta?.path ?? "/zh/guanyu/pininfarina-academy",
    meta: academyBGRCYtxklWMeta || {},
    alias: academyBGRCYtxklWMeta?.alias || [],
    redirect: academyBGRCYtxklWMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/academy.vue").then(m => m.default || m)
  },
  {
    name: awardsqaZjDyMWuEMeta?.name ?? "about-awards___de",
    path: awardsqaZjDyMWuEMeta?.path ?? "/de/um/auszeichnungen",
    meta: awardsqaZjDyMWuEMeta || {},
    alias: awardsqaZjDyMWuEMeta?.alias || [],
    redirect: awardsqaZjDyMWuEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsqaZjDyMWuEMeta?.name ?? "about-awards___en___default",
    path: awardsqaZjDyMWuEMeta?.path ?? "/about/awards",
    meta: awardsqaZjDyMWuEMeta || {},
    alias: awardsqaZjDyMWuEMeta?.alias || [],
    redirect: awardsqaZjDyMWuEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsqaZjDyMWuEMeta?.name ?? "about-awards___en",
    path: awardsqaZjDyMWuEMeta?.path ?? "/en/about/awards",
    meta: awardsqaZjDyMWuEMeta || {},
    alias: awardsqaZjDyMWuEMeta?.alias || [],
    redirect: awardsqaZjDyMWuEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsqaZjDyMWuEMeta?.name ?? "about-awards___it",
    path: awardsqaZjDyMWuEMeta?.path ?? "/it/about/premi",
    meta: awardsqaZjDyMWuEMeta || {},
    alias: awardsqaZjDyMWuEMeta?.alias || [],
    redirect: awardsqaZjDyMWuEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsqaZjDyMWuEMeta?.name ?? "about-awards___zh",
    path: awardsqaZjDyMWuEMeta?.path ?? "/zh/guanyu/jiangxiang",
    meta: awardsqaZjDyMWuEMeta || {},
    alias: awardsqaZjDyMWuEMeta?.alias || [],
    redirect: awardsqaZjDyMWuEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/awards.vue").then(m => m.default || m)
  },
  {
    name: certificationsf5A2acsZHcMeta?.name ?? "about-certifications___de",
    path: certificationsf5A2acsZHcMeta?.path ?? "/de/about/certifications",
    meta: certificationsf5A2acsZHcMeta || {},
    alias: certificationsf5A2acsZHcMeta?.alias || [],
    redirect: certificationsf5A2acsZHcMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/certifications.vue").then(m => m.default || m)
  },
  {
    name: certificationsf5A2acsZHcMeta?.name ?? "about-certifications___en___default",
    path: certificationsf5A2acsZHcMeta?.path ?? "/about/certifications",
    meta: certificationsf5A2acsZHcMeta || {},
    alias: certificationsf5A2acsZHcMeta?.alias || [],
    redirect: certificationsf5A2acsZHcMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/certifications.vue").then(m => m.default || m)
  },
  {
    name: certificationsf5A2acsZHcMeta?.name ?? "about-certifications___en",
    path: certificationsf5A2acsZHcMeta?.path ?? "/en/about/certifications",
    meta: certificationsf5A2acsZHcMeta || {},
    alias: certificationsf5A2acsZHcMeta?.alias || [],
    redirect: certificationsf5A2acsZHcMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/certifications.vue").then(m => m.default || m)
  },
  {
    name: certificationsf5A2acsZHcMeta?.name ?? "about-certifications___it",
    path: certificationsf5A2acsZHcMeta?.path ?? "/it/about/certifications",
    meta: certificationsf5A2acsZHcMeta || {},
    alias: certificationsf5A2acsZHcMeta?.alias || [],
    redirect: certificationsf5A2acsZHcMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/certifications.vue").then(m => m.default || m)
  },
  {
    name: certificationsf5A2acsZHcMeta?.name ?? "about-certifications___zh",
    path: certificationsf5A2acsZHcMeta?.path ?? "/zh/about/certifications",
    meta: certificationsf5A2acsZHcMeta || {},
    alias: certificationsf5A2acsZHcMeta?.alias || [],
    redirect: certificationsf5A2acsZHcMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/certifications.vue").then(m => m.default || m)
  },
  {
    name: heritageoQv1JjqU1nMeta?.name ?? "about-heritage___de",
    path: heritageoQv1JjqU1nMeta?.path ?? "/de/um/erbe",
    meta: heritageoQv1JjqU1nMeta || {},
    alias: heritageoQv1JjqU1nMeta?.alias || [],
    redirect: heritageoQv1JjqU1nMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/heritage.vue").then(m => m.default || m)
  },
  {
    name: heritageoQv1JjqU1nMeta?.name ?? "about-heritage___en___default",
    path: heritageoQv1JjqU1nMeta?.path ?? "/about/heritage",
    meta: heritageoQv1JjqU1nMeta || {},
    alias: heritageoQv1JjqU1nMeta?.alias || [],
    redirect: heritageoQv1JjqU1nMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/heritage.vue").then(m => m.default || m)
  },
  {
    name: heritageoQv1JjqU1nMeta?.name ?? "about-heritage___en",
    path: heritageoQv1JjqU1nMeta?.path ?? "/en/about/heritage",
    meta: heritageoQv1JjqU1nMeta || {},
    alias: heritageoQv1JjqU1nMeta?.alias || [],
    redirect: heritageoQv1JjqU1nMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/heritage.vue").then(m => m.default || m)
  },
  {
    name: heritageoQv1JjqU1nMeta?.name ?? "about-heritage___it",
    path: heritageoQv1JjqU1nMeta?.path ?? "/it/about/heritage",
    meta: heritageoQv1JjqU1nMeta || {},
    alias: heritageoQv1JjqU1nMeta?.alias || [],
    redirect: heritageoQv1JjqU1nMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/heritage.vue").then(m => m.default || m)
  },
  {
    name: heritageoQv1JjqU1nMeta?.name ?? "about-heritage___zh",
    path: heritageoQv1JjqU1nMeta?.path ?? "/zh/guanyu/yichan",
    meta: heritageoQv1JjqU1nMeta || {},
    alias: heritageoQv1JjqU1nMeta?.alias || [],
    redirect: heritageoQv1JjqU1nMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/heritage.vue").then(m => m.default || m)
  },
  {
    name: indexMBx3sR8imrMeta?.name ?? "about___de",
    path: indexMBx3sR8imrMeta?.path ?? "/de/um",
    meta: indexMBx3sR8imrMeta || {},
    alias: indexMBx3sR8imrMeta?.alias || [],
    redirect: indexMBx3sR8imrMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: indexMBx3sR8imrMeta?.name ?? "about___en___default",
    path: indexMBx3sR8imrMeta?.path ?? "/about/",
    meta: indexMBx3sR8imrMeta || {},
    alias: indexMBx3sR8imrMeta?.alias || [],
    redirect: indexMBx3sR8imrMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: indexMBx3sR8imrMeta?.name ?? "about___en",
    path: indexMBx3sR8imrMeta?.path ?? "/en/about",
    meta: indexMBx3sR8imrMeta || {},
    alias: indexMBx3sR8imrMeta?.alias || [],
    redirect: indexMBx3sR8imrMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: indexMBx3sR8imrMeta?.name ?? "about___it",
    path: indexMBx3sR8imrMeta?.path ?? "/it/about",
    meta: indexMBx3sR8imrMeta || {},
    alias: indexMBx3sR8imrMeta?.alias || [],
    redirect: indexMBx3sR8imrMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: indexMBx3sR8imrMeta?.name ?? "about___zh",
    path: indexMBx3sR8imrMeta?.path ?? "/zh/guanyu",
    meta: indexMBx3sR8imrMeta || {},
    alias: indexMBx3sR8imrMeta?.alias || [],
    redirect: indexMBx3sR8imrMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: our_45group7SMqHZKn4YMeta?.name ?? "about-our-group___de",
    path: our_45group7SMqHZKn4YMeta?.path ?? "/de/um/unsere-gruppe",
    meta: our_45group7SMqHZKn4YMeta || {},
    alias: our_45group7SMqHZKn4YMeta?.alias || [],
    redirect: our_45group7SMqHZKn4YMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/our-group.vue").then(m => m.default || m)
  },
  {
    name: our_45group7SMqHZKn4YMeta?.name ?? "about-our-group___en___default",
    path: our_45group7SMqHZKn4YMeta?.path ?? "/about/our-group",
    meta: our_45group7SMqHZKn4YMeta || {},
    alias: our_45group7SMqHZKn4YMeta?.alias || [],
    redirect: our_45group7SMqHZKn4YMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/our-group.vue").then(m => m.default || m)
  },
  {
    name: our_45group7SMqHZKn4YMeta?.name ?? "about-our-group___en",
    path: our_45group7SMqHZKn4YMeta?.path ?? "/en/about/our-group",
    meta: our_45group7SMqHZKn4YMeta || {},
    alias: our_45group7SMqHZKn4YMeta?.alias || [],
    redirect: our_45group7SMqHZKn4YMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/our-group.vue").then(m => m.default || m)
  },
  {
    name: our_45group7SMqHZKn4YMeta?.name ?? "about-our-group___it",
    path: our_45group7SMqHZKn4YMeta?.path ?? "/it/about/il-gruppo",
    meta: our_45group7SMqHZKn4YMeta || {},
    alias: our_45group7SMqHZKn4YMeta?.alias || [],
    redirect: our_45group7SMqHZKn4YMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/our-group.vue").then(m => m.default || m)
  },
  {
    name: our_45group7SMqHZKn4YMeta?.name ?? "about-our-group___zh",
    path: our_45group7SMqHZKn4YMeta?.path ?? "/zh/guanyu/women-de-zu",
    meta: our_45group7SMqHZKn4YMeta || {},
    alias: our_45group7SMqHZKn4YMeta?.alias || [],
    redirect: our_45group7SMqHZKn4YMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/our-group.vue").then(m => m.default || m)
  },
  {
    name: partnersGPexttgVJLMeta?.name ?? "about-partners___de",
    path: partnersGPexttgVJLMeta?.path ?? "/de/about/partners",
    meta: partnersGPexttgVJLMeta || {},
    alias: partnersGPexttgVJLMeta?.alias || [],
    redirect: partnersGPexttgVJLMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersGPexttgVJLMeta?.name ?? "about-partners___en___default",
    path: partnersGPexttgVJLMeta?.path ?? "/about/partners",
    meta: partnersGPexttgVJLMeta || {},
    alias: partnersGPexttgVJLMeta?.alias || [],
    redirect: partnersGPexttgVJLMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersGPexttgVJLMeta?.name ?? "about-partners___en",
    path: partnersGPexttgVJLMeta?.path ?? "/en/about/partners",
    meta: partnersGPexttgVJLMeta || {},
    alias: partnersGPexttgVJLMeta?.alias || [],
    redirect: partnersGPexttgVJLMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersGPexttgVJLMeta?.name ?? "about-partners___it",
    path: partnersGPexttgVJLMeta?.path ?? "/it/about/partners",
    meta: partnersGPexttgVJLMeta || {},
    alias: partnersGPexttgVJLMeta?.alias || [],
    redirect: partnersGPexttgVJLMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersGPexttgVJLMeta?.name ?? "about-partners___zh",
    path: partnersGPexttgVJLMeta?.path ?? "/zh/about/partners",
    meta: partnersGPexttgVJLMeta || {},
    alias: partnersGPexttgVJLMeta?.alias || [],
    redirect: partnersGPexttgVJLMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/partners.vue").then(m => m.default || m)
  },
  {
    name: sustainability9nrTUcJYF9Meta?.name ?? "about-sustainability___de",
    path: sustainability9nrTUcJYF9Meta?.path ?? "/de/um/nachhaltigkeit",
    meta: sustainability9nrTUcJYF9Meta || {},
    alias: sustainability9nrTUcJYF9Meta?.alias || [],
    redirect: sustainability9nrTUcJYF9Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/sustainability.vue").then(m => m.default || m)
  },
  {
    name: sustainability9nrTUcJYF9Meta?.name ?? "about-sustainability___en___default",
    path: sustainability9nrTUcJYF9Meta?.path ?? "/about/sustainability",
    meta: sustainability9nrTUcJYF9Meta || {},
    alias: sustainability9nrTUcJYF9Meta?.alias || [],
    redirect: sustainability9nrTUcJYF9Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/sustainability.vue").then(m => m.default || m)
  },
  {
    name: sustainability9nrTUcJYF9Meta?.name ?? "about-sustainability___en",
    path: sustainability9nrTUcJYF9Meta?.path ?? "/en/about/sustainability",
    meta: sustainability9nrTUcJYF9Meta || {},
    alias: sustainability9nrTUcJYF9Meta?.alias || [],
    redirect: sustainability9nrTUcJYF9Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/sustainability.vue").then(m => m.default || m)
  },
  {
    name: sustainability9nrTUcJYF9Meta?.name ?? "about-sustainability___it",
    path: sustainability9nrTUcJYF9Meta?.path ?? "/it/about/sostenibilita",
    meta: sustainability9nrTUcJYF9Meta || {},
    alias: sustainability9nrTUcJYF9Meta?.alias || [],
    redirect: sustainability9nrTUcJYF9Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/sustainability.vue").then(m => m.default || m)
  },
  {
    name: sustainability9nrTUcJYF9Meta?.name ?? "about-sustainability___zh",
    path: sustainability9nrTUcJYF9Meta?.path ?? "/zh/guanyu/ke-chixu-xing",
    meta: sustainability9nrTUcJYF9Meta || {},
    alias: sustainability9nrTUcJYF9Meta?.alias || [],
    redirect: sustainability9nrTUcJYF9Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/sustainability.vue").then(m => m.default || m)
  },
  {
    name: teamKPxY4WTxzGMeta?.name ?? "about-team___de",
    path: teamKPxY4WTxzGMeta?.path ?? "/de/um/team",
    meta: teamKPxY4WTxzGMeta || {},
    alias: teamKPxY4WTxzGMeta?.alias || [],
    redirect: teamKPxY4WTxzGMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/team.vue").then(m => m.default || m)
  },
  {
    name: teamKPxY4WTxzGMeta?.name ?? "about-team___en___default",
    path: teamKPxY4WTxzGMeta?.path ?? "/about/team",
    meta: teamKPxY4WTxzGMeta || {},
    alias: teamKPxY4WTxzGMeta?.alias || [],
    redirect: teamKPxY4WTxzGMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/team.vue").then(m => m.default || m)
  },
  {
    name: teamKPxY4WTxzGMeta?.name ?? "about-team___en",
    path: teamKPxY4WTxzGMeta?.path ?? "/en/about/team",
    meta: teamKPxY4WTxzGMeta || {},
    alias: teamKPxY4WTxzGMeta?.alias || [],
    redirect: teamKPxY4WTxzGMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/team.vue").then(m => m.default || m)
  },
  {
    name: teamKPxY4WTxzGMeta?.name ?? "about-team___it",
    path: teamKPxY4WTxzGMeta?.path ?? "/it/about/team",
    meta: teamKPxY4WTxzGMeta || {},
    alias: teamKPxY4WTxzGMeta?.alias || [],
    redirect: teamKPxY4WTxzGMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/team.vue").then(m => m.default || m)
  },
  {
    name: teamKPxY4WTxzGMeta?.name ?? "about-team___zh",
    path: teamKPxY4WTxzGMeta?.path ?? "/zh/guanyu/tuandui",
    meta: teamKPxY4WTxzGMeta || {},
    alias: teamKPxY4WTxzGMeta?.alias || [],
    redirect: teamKPxY4WTxzGMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/team.vue").then(m => m.default || m)
  },
  {
    name: visit_45pininfarinaqpKPmttdKBMeta?.name ?? "about-visit-pininfarina___de",
    path: visit_45pininfarinaqpKPmttdKBMeta?.path ?? "/de/um/besuchen-sie-pininfarina",
    meta: visit_45pininfarinaqpKPmttdKBMeta || {},
    alias: visit_45pininfarinaqpKPmttdKBMeta?.alias || [],
    redirect: visit_45pininfarinaqpKPmttdKBMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/visit-pininfarina.vue").then(m => m.default || m)
  },
  {
    name: visit_45pininfarinaqpKPmttdKBMeta?.name ?? "about-visit-pininfarina___en___default",
    path: visit_45pininfarinaqpKPmttdKBMeta?.path ?? "/about/visit-pininfarina",
    meta: visit_45pininfarinaqpKPmttdKBMeta || {},
    alias: visit_45pininfarinaqpKPmttdKBMeta?.alias || [],
    redirect: visit_45pininfarinaqpKPmttdKBMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/visit-pininfarina.vue").then(m => m.default || m)
  },
  {
    name: visit_45pininfarinaqpKPmttdKBMeta?.name ?? "about-visit-pininfarina___en",
    path: visit_45pininfarinaqpKPmttdKBMeta?.path ?? "/en/about/visit-pininfarina",
    meta: visit_45pininfarinaqpKPmttdKBMeta || {},
    alias: visit_45pininfarinaqpKPmttdKBMeta?.alias || [],
    redirect: visit_45pininfarinaqpKPmttdKBMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/visit-pininfarina.vue").then(m => m.default || m)
  },
  {
    name: visit_45pininfarinaqpKPmttdKBMeta?.name ?? "about-visit-pininfarina___it",
    path: visit_45pininfarinaqpKPmttdKBMeta?.path ?? "/it/about/visita-pininfarina",
    meta: visit_45pininfarinaqpKPmttdKBMeta || {},
    alias: visit_45pininfarinaqpKPmttdKBMeta?.alias || [],
    redirect: visit_45pininfarinaqpKPmttdKBMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/visit-pininfarina.vue").then(m => m.default || m)
  },
  {
    name: visit_45pininfarinaqpKPmttdKBMeta?.name ?? "about-visit-pininfarina___zh",
    path: visit_45pininfarinaqpKPmttdKBMeta?.path ?? "/zh/guanyu/hui-pininfarina",
    meta: visit_45pininfarinaqpKPmttdKBMeta || {},
    alias: visit_45pininfarinaqpKPmttdKBMeta?.alias || [],
    redirect: visit_45pininfarinaqpKPmttdKBMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/about/visit-pininfarina.vue").then(m => m.default || m)
  },
  {
    name: index6aIGjy6gaaMeta?.name ?? "approach___de",
    path: index6aIGjy6gaaMeta?.path ?? "/de/approach",
    meta: index6aIGjy6gaaMeta || {},
    alias: index6aIGjy6gaaMeta?.alias || [],
    redirect: index6aIGjy6gaaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/approach/index.vue").then(m => m.default || m)
  },
  {
    name: index6aIGjy6gaaMeta?.name ?? "approach___en___default",
    path: index6aIGjy6gaaMeta?.path ?? "/approach",
    meta: index6aIGjy6gaaMeta || {},
    alias: index6aIGjy6gaaMeta?.alias || [],
    redirect: index6aIGjy6gaaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/approach/index.vue").then(m => m.default || m)
  },
  {
    name: index6aIGjy6gaaMeta?.name ?? "approach___en",
    path: index6aIGjy6gaaMeta?.path ?? "/en/approach",
    meta: index6aIGjy6gaaMeta || {},
    alias: index6aIGjy6gaaMeta?.alias || [],
    redirect: index6aIGjy6gaaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/approach/index.vue").then(m => m.default || m)
  },
  {
    name: index6aIGjy6gaaMeta?.name ?? "approach___it",
    path: index6aIGjy6gaaMeta?.path ?? "/it/approach",
    meta: index6aIGjy6gaaMeta || {},
    alias: index6aIGjy6gaaMeta?.alias || [],
    redirect: index6aIGjy6gaaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/approach/index.vue").then(m => m.default || m)
  },
  {
    name: index6aIGjy6gaaMeta?.name ?? "approach___zh",
    path: index6aIGjy6gaaMeta?.path ?? "/zh/approach",
    meta: index6aIGjy6gaaMeta || {},
    alias: index6aIGjy6gaaMeta?.alias || [],
    redirect: index6aIGjy6gaaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/approach/index.vue").then(m => m.default || m)
  },
  {
    name: methodologygMqDa6ek4TMeta?.name ?? "approach-methodology___de",
    path: methodologygMqDa6ek4TMeta?.path ?? "/de/approach/methodology",
    meta: methodologygMqDa6ek4TMeta || {},
    alias: methodologygMqDa6ek4TMeta?.alias || [],
    redirect: methodologygMqDa6ek4TMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/approach/methodology.vue").then(m => m.default || m)
  },
  {
    name: methodologygMqDa6ek4TMeta?.name ?? "approach-methodology___en___default",
    path: methodologygMqDa6ek4TMeta?.path ?? "/approach/methodology",
    meta: methodologygMqDa6ek4TMeta || {},
    alias: methodologygMqDa6ek4TMeta?.alias || [],
    redirect: methodologygMqDa6ek4TMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/approach/methodology.vue").then(m => m.default || m)
  },
  {
    name: methodologygMqDa6ek4TMeta?.name ?? "approach-methodology___en",
    path: methodologygMqDa6ek4TMeta?.path ?? "/en/approach/methodology",
    meta: methodologygMqDa6ek4TMeta || {},
    alias: methodologygMqDa6ek4TMeta?.alias || [],
    redirect: methodologygMqDa6ek4TMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/approach/methodology.vue").then(m => m.default || m)
  },
  {
    name: methodologygMqDa6ek4TMeta?.name ?? "approach-methodology___it",
    path: methodologygMqDa6ek4TMeta?.path ?? "/it/approach/methodology",
    meta: methodologygMqDa6ek4TMeta || {},
    alias: methodologygMqDa6ek4TMeta?.alias || [],
    redirect: methodologygMqDa6ek4TMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/approach/methodology.vue").then(m => m.default || m)
  },
  {
    name: methodologygMqDa6ek4TMeta?.name ?? "approach-methodology___zh",
    path: methodologygMqDa6ek4TMeta?.path ?? "/zh/approach/methodology",
    meta: methodologygMqDa6ek4TMeta || {},
    alias: methodologygMqDa6ek4TMeta?.alias || [],
    redirect: methodologygMqDa6ek4TMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/approach/methodology.vue").then(m => m.default || m)
  },
  {
    name: _91jobSlug_930MbZ3FBQAaMeta?.name ?? "careers-jobSlug___de",
    path: _91jobSlug_930MbZ3FBQAaMeta?.path ?? "/de/karriere/:jobSlug",
    meta: _91jobSlug_930MbZ3FBQAaMeta || {},
    alias: _91jobSlug_930MbZ3FBQAaMeta?.alias || [],
    redirect: _91jobSlug_930MbZ3FBQAaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/careers/[jobSlug].vue").then(m => m.default || m)
  },
  {
    name: _91jobSlug_930MbZ3FBQAaMeta?.name ?? "careers-jobSlug___en___default",
    path: _91jobSlug_930MbZ3FBQAaMeta?.path ?? "/careers/:jobSlug",
    meta: _91jobSlug_930MbZ3FBQAaMeta || {},
    alias: _91jobSlug_930MbZ3FBQAaMeta?.alias || [],
    redirect: _91jobSlug_930MbZ3FBQAaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/careers/[jobSlug].vue").then(m => m.default || m)
  },
  {
    name: _91jobSlug_930MbZ3FBQAaMeta?.name ?? "careers-jobSlug___en",
    path: _91jobSlug_930MbZ3FBQAaMeta?.path ?? "/en/careers/:jobSlug",
    meta: _91jobSlug_930MbZ3FBQAaMeta || {},
    alias: _91jobSlug_930MbZ3FBQAaMeta?.alias || [],
    redirect: _91jobSlug_930MbZ3FBQAaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/careers/[jobSlug].vue").then(m => m.default || m)
  },
  {
    name: _91jobSlug_930MbZ3FBQAaMeta?.name ?? "careers-jobSlug___it",
    path: _91jobSlug_930MbZ3FBQAaMeta?.path ?? "/it/carriere/:jobSlug",
    meta: _91jobSlug_930MbZ3FBQAaMeta || {},
    alias: _91jobSlug_930MbZ3FBQAaMeta?.alias || [],
    redirect: _91jobSlug_930MbZ3FBQAaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/careers/[jobSlug].vue").then(m => m.default || m)
  },
  {
    name: _91jobSlug_930MbZ3FBQAaMeta?.name ?? "careers-jobSlug___zh",
    path: _91jobSlug_930MbZ3FBQAaMeta?.path ?? "/zh/zhiye-shengya/:jobSlug",
    meta: _91jobSlug_930MbZ3FBQAaMeta || {},
    alias: _91jobSlug_930MbZ3FBQAaMeta?.alias || [],
    redirect: _91jobSlug_930MbZ3FBQAaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/careers/[jobSlug].vue").then(m => m.default || m)
  },
  {
    name: indexv3HDHsi6PfMeta?.name ?? "careers___de",
    path: indexv3HDHsi6PfMeta?.path ?? "/de/karriere",
    meta: indexv3HDHsi6PfMeta || {},
    alias: indexv3HDHsi6PfMeta?.alias || [],
    redirect: indexv3HDHsi6PfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/careers/index.vue").then(m => m.default || m)
  },
  {
    name: indexv3HDHsi6PfMeta?.name ?? "careers___en___default",
    path: indexv3HDHsi6PfMeta?.path ?? "/careers/",
    meta: indexv3HDHsi6PfMeta || {},
    alias: indexv3HDHsi6PfMeta?.alias || [],
    redirect: indexv3HDHsi6PfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/careers/index.vue").then(m => m.default || m)
  },
  {
    name: indexv3HDHsi6PfMeta?.name ?? "careers___en",
    path: indexv3HDHsi6PfMeta?.path ?? "/en/careers",
    meta: indexv3HDHsi6PfMeta || {},
    alias: indexv3HDHsi6PfMeta?.alias || [],
    redirect: indexv3HDHsi6PfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/careers/index.vue").then(m => m.default || m)
  },
  {
    name: indexv3HDHsi6PfMeta?.name ?? "careers___it",
    path: indexv3HDHsi6PfMeta?.path ?? "/it/carriere",
    meta: indexv3HDHsi6PfMeta || {},
    alias: indexv3HDHsi6PfMeta?.alias || [],
    redirect: indexv3HDHsi6PfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/careers/index.vue").then(m => m.default || m)
  },
  {
    name: indexv3HDHsi6PfMeta?.name ?? "careers___zh",
    path: indexv3HDHsi6PfMeta?.path ?? "/zh/zhiye-shengya",
    meta: indexv3HDHsi6PfMeta || {},
    alias: indexv3HDHsi6PfMeta?.alias || [],
    redirect: indexv3HDHsi6PfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/careers/index.vue").then(m => m.default || m)
  },
  {
    name: indexB3mM5oiVA2Meta?.name ?? "classiche___de",
    path: indexB3mM5oiVA2Meta?.path ?? "/de/classiche",
    meta: indexB3mM5oiVA2Meta || {},
    alias: indexB3mM5oiVA2Meta?.alias || [],
    redirect: indexB3mM5oiVA2Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/classiche/index.vue").then(m => m.default || m)
  },
  {
    name: indexB3mM5oiVA2Meta?.name ?? "classiche___en___default",
    path: indexB3mM5oiVA2Meta?.path ?? "/classiche/",
    meta: indexB3mM5oiVA2Meta || {},
    alias: indexB3mM5oiVA2Meta?.alias || [],
    redirect: indexB3mM5oiVA2Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/classiche/index.vue").then(m => m.default || m)
  },
  {
    name: indexB3mM5oiVA2Meta?.name ?? "classiche___en",
    path: indexB3mM5oiVA2Meta?.path ?? "/en/classiche",
    meta: indexB3mM5oiVA2Meta || {},
    alias: indexB3mM5oiVA2Meta?.alias || [],
    redirect: indexB3mM5oiVA2Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/classiche/index.vue").then(m => m.default || m)
  },
  {
    name: indexB3mM5oiVA2Meta?.name ?? "classiche___it",
    path: indexB3mM5oiVA2Meta?.path ?? "/it/classiche",
    meta: indexB3mM5oiVA2Meta || {},
    alias: indexB3mM5oiVA2Meta?.alias || [],
    redirect: indexB3mM5oiVA2Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/classiche/index.vue").then(m => m.default || m)
  },
  {
    name: indexB3mM5oiVA2Meta?.name ?? "classiche___zh",
    path: indexB3mM5oiVA2Meta?.path ?? "/zh/classiche",
    meta: indexB3mM5oiVA2Meta || {},
    alias: indexB3mM5oiVA2Meta?.alias || [],
    redirect: indexB3mM5oiVA2Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/classiche/index.vue").then(m => m.default || m)
  },
  {
    name: _91countrySlug_93edvwhUqYNhMeta?.name ?? "contacts-countrySlug___de",
    path: _91countrySlug_93edvwhUqYNhMeta?.path ?? "/de/kontakte/:countrySlug",
    meta: _91countrySlug_93edvwhUqYNhMeta || {},
    alias: _91countrySlug_93edvwhUqYNhMeta?.alias || [],
    redirect: _91countrySlug_93edvwhUqYNhMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/[countrySlug].vue").then(m => m.default || m)
  },
  {
    name: _91countrySlug_93edvwhUqYNhMeta?.name ?? "contacts-countrySlug___en___default",
    path: _91countrySlug_93edvwhUqYNhMeta?.path ?? "/contacts/:countrySlug",
    meta: _91countrySlug_93edvwhUqYNhMeta || {},
    alias: _91countrySlug_93edvwhUqYNhMeta?.alias || [],
    redirect: _91countrySlug_93edvwhUqYNhMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/[countrySlug].vue").then(m => m.default || m)
  },
  {
    name: _91countrySlug_93edvwhUqYNhMeta?.name ?? "contacts-countrySlug___en",
    path: _91countrySlug_93edvwhUqYNhMeta?.path ?? "/en/contacts/:countrySlug",
    meta: _91countrySlug_93edvwhUqYNhMeta || {},
    alias: _91countrySlug_93edvwhUqYNhMeta?.alias || [],
    redirect: _91countrySlug_93edvwhUqYNhMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/[countrySlug].vue").then(m => m.default || m)
  },
  {
    name: _91countrySlug_93edvwhUqYNhMeta?.name ?? "contacts-countrySlug___it",
    path: _91countrySlug_93edvwhUqYNhMeta?.path ?? "/it/contatti/:countrySlug",
    meta: _91countrySlug_93edvwhUqYNhMeta || {},
    alias: _91countrySlug_93edvwhUqYNhMeta?.alias || [],
    redirect: _91countrySlug_93edvwhUqYNhMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/[countrySlug].vue").then(m => m.default || m)
  },
  {
    name: _91countrySlug_93edvwhUqYNhMeta?.name ?? "contacts-countrySlug___zh",
    path: _91countrySlug_93edvwhUqYNhMeta?.path ?? "/zh/lianxi-ren/:countrySlug",
    meta: _91countrySlug_93edvwhUqYNhMeta || {},
    alias: _91countrySlug_93edvwhUqYNhMeta?.alias || [],
    redirect: _91countrySlug_93edvwhUqYNhMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/[countrySlug].vue").then(m => m.default || m)
  },
  {
    name: indexzIC5OMk8F4Meta?.name ?? "contacts___de",
    path: indexzIC5OMk8F4Meta?.path ?? "/de/kontakte",
    meta: indexzIC5OMk8F4Meta || {},
    alias: indexzIC5OMk8F4Meta?.alias || [],
    redirect: indexzIC5OMk8F4Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/index.vue").then(m => m.default || m)
  },
  {
    name: indexzIC5OMk8F4Meta?.name ?? "contacts___en___default",
    path: indexzIC5OMk8F4Meta?.path ?? "/contacts/",
    meta: indexzIC5OMk8F4Meta || {},
    alias: indexzIC5OMk8F4Meta?.alias || [],
    redirect: indexzIC5OMk8F4Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/index.vue").then(m => m.default || m)
  },
  {
    name: indexzIC5OMk8F4Meta?.name ?? "contacts___en",
    path: indexzIC5OMk8F4Meta?.path ?? "/en/contacts",
    meta: indexzIC5OMk8F4Meta || {},
    alias: indexzIC5OMk8F4Meta?.alias || [],
    redirect: indexzIC5OMk8F4Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/index.vue").then(m => m.default || m)
  },
  {
    name: indexzIC5OMk8F4Meta?.name ?? "contacts___it",
    path: indexzIC5OMk8F4Meta?.path ?? "/it/contatti",
    meta: indexzIC5OMk8F4Meta || {},
    alias: indexzIC5OMk8F4Meta?.alias || [],
    redirect: indexzIC5OMk8F4Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/index.vue").then(m => m.default || m)
  },
  {
    name: indexzIC5OMk8F4Meta?.name ?? "contacts___zh",
    path: indexzIC5OMk8F4Meta?.path ?? "/zh/lianxi-ren",
    meta: indexzIC5OMk8F4Meta || {},
    alias: indexzIC5OMk8F4Meta?.alias || [],
    redirect: indexzIC5OMk8F4Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/index.vue").then(m => m.default || m)
  },
  {
    name: messageSentDPKZeEVKfMMeta?.name ?? "contacts-messageSent___de",
    path: messageSentDPKZeEVKfMMeta?.path ?? "/de/message-sent",
    meta: messageSentDPKZeEVKfMMeta || {},
    alias: messageSentDPKZeEVKfMMeta?.alias || [],
    redirect: messageSentDPKZeEVKfMMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/messageSent.vue").then(m => m.default || m)
  },
  {
    name: messageSentDPKZeEVKfMMeta?.name ?? "contacts-messageSent___en___default",
    path: messageSentDPKZeEVKfMMeta?.path ?? "/message-sent",
    meta: messageSentDPKZeEVKfMMeta || {},
    alias: messageSentDPKZeEVKfMMeta?.alias || [],
    redirect: messageSentDPKZeEVKfMMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/messageSent.vue").then(m => m.default || m)
  },
  {
    name: messageSentDPKZeEVKfMMeta?.name ?? "contacts-messageSent___en",
    path: messageSentDPKZeEVKfMMeta?.path ?? "/en/message-sent",
    meta: messageSentDPKZeEVKfMMeta || {},
    alias: messageSentDPKZeEVKfMMeta?.alias || [],
    redirect: messageSentDPKZeEVKfMMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/messageSent.vue").then(m => m.default || m)
  },
  {
    name: messageSentDPKZeEVKfMMeta?.name ?? "contacts-messageSent___it",
    path: messageSentDPKZeEVKfMMeta?.path ?? "/it/message-sent",
    meta: messageSentDPKZeEVKfMMeta || {},
    alias: messageSentDPKZeEVKfMMeta?.alias || [],
    redirect: messageSentDPKZeEVKfMMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/messageSent.vue").then(m => m.default || m)
  },
  {
    name: messageSentDPKZeEVKfMMeta?.name ?? "contacts-messageSent___zh",
    path: messageSentDPKZeEVKfMMeta?.path ?? "/zh/message-sent",
    meta: messageSentDPKZeEVKfMMeta || {},
    alias: messageSentDPKZeEVKfMMeta?.alias || [],
    redirect: messageSentDPKZeEVKfMMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/messageSent.vue").then(m => m.default || m)
  },
  {
    name: our_45officesaBOlLiagr0Meta?.name ?? "contacts-our-offices___de",
    path: our_45officesaBOlLiagr0Meta?.path ?? "/de/kontakte/unsere-gruppe",
    meta: our_45officesaBOlLiagr0Meta || {},
    alias: our_45officesaBOlLiagr0Meta?.alias || [],
    redirect: our_45officesaBOlLiagr0Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/our-offices.vue").then(m => m.default || m)
  },
  {
    name: our_45officesaBOlLiagr0Meta?.name ?? "contacts-our-offices___en___default",
    path: our_45officesaBOlLiagr0Meta?.path ?? "/contacts/our-offices",
    meta: our_45officesaBOlLiagr0Meta || {},
    alias: our_45officesaBOlLiagr0Meta?.alias || [],
    redirect: our_45officesaBOlLiagr0Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/our-offices.vue").then(m => m.default || m)
  },
  {
    name: our_45officesaBOlLiagr0Meta?.name ?? "contacts-our-offices___en",
    path: our_45officesaBOlLiagr0Meta?.path ?? "/en/contacts/our-offices",
    meta: our_45officesaBOlLiagr0Meta || {},
    alias: our_45officesaBOlLiagr0Meta?.alias || [],
    redirect: our_45officesaBOlLiagr0Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/our-offices.vue").then(m => m.default || m)
  },
  {
    name: our_45officesaBOlLiagr0Meta?.name ?? "contacts-our-offices___it",
    path: our_45officesaBOlLiagr0Meta?.path ?? "/it/contatti/i-nostri-uffici",
    meta: our_45officesaBOlLiagr0Meta || {},
    alias: our_45officesaBOlLiagr0Meta?.alias || [],
    redirect: our_45officesaBOlLiagr0Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/our-offices.vue").then(m => m.default || m)
  },
  {
    name: our_45officesaBOlLiagr0Meta?.name ?? "contacts-our-offices___zh",
    path: our_45officesaBOlLiagr0Meta?.path ?? "/zh/lianxi-ren/women-de-zu",
    meta: our_45officesaBOlLiagr0Meta || {},
    alias: our_45officesaBOlLiagr0Meta?.alias || [],
    redirect: our_45officesaBOlLiagr0Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/contacts/our-offices.vue").then(m => m.default || m)
  },
  {
    name: cookie_45policyrLf6xOLSIfMeta?.name ?? "cookie-policy___de",
    path: cookie_45policyrLf6xOLSIfMeta?.path ?? "/de/cookie-policy",
    meta: cookie_45policyrLf6xOLSIfMeta || {},
    alias: cookie_45policyrLf6xOLSIfMeta?.alias || [],
    redirect: cookie_45policyrLf6xOLSIfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: cookie_45policyrLf6xOLSIfMeta?.name ?? "cookie-policy___en___default",
    path: cookie_45policyrLf6xOLSIfMeta?.path ?? "/cookie-policy/",
    meta: cookie_45policyrLf6xOLSIfMeta || {},
    alias: cookie_45policyrLf6xOLSIfMeta?.alias || [],
    redirect: cookie_45policyrLf6xOLSIfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: cookie_45policyrLf6xOLSIfMeta?.name ?? "cookie-policy___en",
    path: cookie_45policyrLf6xOLSIfMeta?.path ?? "/en/cookie-policy",
    meta: cookie_45policyrLf6xOLSIfMeta || {},
    alias: cookie_45policyrLf6xOLSIfMeta?.alias || [],
    redirect: cookie_45policyrLf6xOLSIfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: cookie_45policyrLf6xOLSIfMeta?.name ?? "cookie-policy___it",
    path: cookie_45policyrLf6xOLSIfMeta?.path ?? "/it/cookie-policy",
    meta: cookie_45policyrLf6xOLSIfMeta || {},
    alias: cookie_45policyrLf6xOLSIfMeta?.alias || [],
    redirect: cookie_45policyrLf6xOLSIfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: cookie_45policyrLf6xOLSIfMeta?.name ?? "cookie-policy___zh",
    path: cookie_45policyrLf6xOLSIfMeta?.path ?? "/zh/cookie-policy",
    meta: cookie_45policyrLf6xOLSIfMeta || {},
    alias: cookie_45policyrLf6xOLSIfMeta?.alias || [],
    redirect: cookie_45policyrLf6xOLSIfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: index1U7rvuFukXMeta?.name ?? "index___de",
    path: index1U7rvuFukXMeta?.path ?? "/de",
    meta: index1U7rvuFukXMeta || {},
    alias: index1U7rvuFukXMeta?.alias || [],
    redirect: index1U7rvuFukXMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index1U7rvuFukXMeta?.name ?? "index___en___default",
    path: index1U7rvuFukXMeta?.path ?? "/",
    meta: index1U7rvuFukXMeta || {},
    alias: index1U7rvuFukXMeta?.alias || [],
    redirect: index1U7rvuFukXMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index1U7rvuFukXMeta?.name ?? "index___en",
    path: index1U7rvuFukXMeta?.path ?? "/en",
    meta: index1U7rvuFukXMeta || {},
    alias: index1U7rvuFukXMeta?.alias || [],
    redirect: index1U7rvuFukXMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index1U7rvuFukXMeta?.name ?? "index___it",
    path: index1U7rvuFukXMeta?.path ?? "/it",
    meta: index1U7rvuFukXMeta || {},
    alias: index1U7rvuFukXMeta?.alias || [],
    redirect: index1U7rvuFukXMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index1U7rvuFukXMeta?.name ?? "index___zh",
    path: index1U7rvuFukXMeta?.path ?? "/zh",
    meta: index1U7rvuFukXMeta || {},
    alias: index1U7rvuFukXMeta?.alias || [],
    redirect: index1U7rvuFukXMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indextIxeaogzOUMeta?.name ?? "investor-relations-investorSlug___de",
    path: indextIxeaogzOUMeta?.path ?? "/de/investor-relations/:investorSlug?",
    meta: indextIxeaogzOUMeta || {},
    alias: indextIxeaogzOUMeta?.alias || [],
    redirect: indextIxeaogzOUMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/investor-relations/[[investorSlug]]/index.vue").then(m => m.default || m)
  },
  {
    name: indextIxeaogzOUMeta?.name ?? "investor-relations-investorSlug___en___default",
    path: indextIxeaogzOUMeta?.path ?? "/investor-relations/:investorSlug?",
    meta: indextIxeaogzOUMeta || {},
    alias: indextIxeaogzOUMeta?.alias || [],
    redirect: indextIxeaogzOUMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/investor-relations/[[investorSlug]]/index.vue").then(m => m.default || m)
  },
  {
    name: indextIxeaogzOUMeta?.name ?? "investor-relations-investorSlug___en",
    path: indextIxeaogzOUMeta?.path ?? "/en/investor-relations/:investorSlug?",
    meta: indextIxeaogzOUMeta || {},
    alias: indextIxeaogzOUMeta?.alias || [],
    redirect: indextIxeaogzOUMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/investor-relations/[[investorSlug]]/index.vue").then(m => m.default || m)
  },
  {
    name: indextIxeaogzOUMeta?.name ?? "investor-relations-investorSlug___it",
    path: indextIxeaogzOUMeta?.path ?? "/it/investor-relations/:investorSlug?",
    meta: indextIxeaogzOUMeta || {},
    alias: indextIxeaogzOUMeta?.alias || [],
    redirect: indextIxeaogzOUMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/investor-relations/[[investorSlug]]/index.vue").then(m => m.default || m)
  },
  {
    name: indextIxeaogzOUMeta?.name ?? "investor-relations-investorSlug___zh",
    path: indextIxeaogzOUMeta?.path ?? "/zh/investor-relations/:investorSlug?",
    meta: indextIxeaogzOUMeta || {},
    alias: indextIxeaogzOUMeta?.alias || [],
    redirect: indextIxeaogzOUMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/investor-relations/[[investorSlug]]/index.vue").then(m => m.default || m)
  },
  {
    name: hq_45resourcesy4dWnZnZAsMeta?.name ?? "media-hub-hq-resources___de",
    path: hq_45resourcesy4dWnZnZAsMeta?.path ?? "/de/media-hub/hq-resources",
    meta: hq_45resourcesy4dWnZnZAsMeta || {},
    alias: hq_45resourcesy4dWnZnZAsMeta?.alias || [],
    redirect: hq_45resourcesy4dWnZnZAsMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/hq-resources.vue").then(m => m.default || m)
  },
  {
    name: hq_45resourcesy4dWnZnZAsMeta?.name ?? "media-hub-hq-resources___en___default",
    path: hq_45resourcesy4dWnZnZAsMeta?.path ?? "/media-hub/hq-resources",
    meta: hq_45resourcesy4dWnZnZAsMeta || {},
    alias: hq_45resourcesy4dWnZnZAsMeta?.alias || [],
    redirect: hq_45resourcesy4dWnZnZAsMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/hq-resources.vue").then(m => m.default || m)
  },
  {
    name: hq_45resourcesy4dWnZnZAsMeta?.name ?? "media-hub-hq-resources___en",
    path: hq_45resourcesy4dWnZnZAsMeta?.path ?? "/en/media-hub/hq-resources",
    meta: hq_45resourcesy4dWnZnZAsMeta || {},
    alias: hq_45resourcesy4dWnZnZAsMeta?.alias || [],
    redirect: hq_45resourcesy4dWnZnZAsMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/hq-resources.vue").then(m => m.default || m)
  },
  {
    name: hq_45resourcesy4dWnZnZAsMeta?.name ?? "media-hub-hq-resources___it",
    path: hq_45resourcesy4dWnZnZAsMeta?.path ?? "/it/media-hub/hq-resources",
    meta: hq_45resourcesy4dWnZnZAsMeta || {},
    alias: hq_45resourcesy4dWnZnZAsMeta?.alias || [],
    redirect: hq_45resourcesy4dWnZnZAsMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/hq-resources.vue").then(m => m.default || m)
  },
  {
    name: hq_45resourcesy4dWnZnZAsMeta?.name ?? "media-hub-hq-resources___zh",
    path: hq_45resourcesy4dWnZnZAsMeta?.path ?? "/zh/media-hub/hq-resources",
    meta: hq_45resourcesy4dWnZnZAsMeta || {},
    alias: hq_45resourcesy4dWnZnZAsMeta?.alias || [],
    redirect: hq_45resourcesy4dWnZnZAsMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/hq-resources.vue").then(m => m.default || m)
  },
  {
    name: indexiF9juaW9yeMeta?.name ?? "media-hub___de",
    path: indexiF9juaW9yeMeta?.path ?? "/de/media-hub",
    meta: indexiF9juaW9yeMeta || {},
    alias: indexiF9juaW9yeMeta?.alias || [],
    redirect: indexiF9juaW9yeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/index.vue").then(m => m.default || m)
  },
  {
    name: indexiF9juaW9yeMeta?.name ?? "media-hub___en___default",
    path: indexiF9juaW9yeMeta?.path ?? "/media-hub/",
    meta: indexiF9juaW9yeMeta || {},
    alias: indexiF9juaW9yeMeta?.alias || [],
    redirect: indexiF9juaW9yeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/index.vue").then(m => m.default || m)
  },
  {
    name: indexiF9juaW9yeMeta?.name ?? "media-hub___en",
    path: indexiF9juaW9yeMeta?.path ?? "/en/media-hub",
    meta: indexiF9juaW9yeMeta || {},
    alias: indexiF9juaW9yeMeta?.alias || [],
    redirect: indexiF9juaW9yeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/index.vue").then(m => m.default || m)
  },
  {
    name: indexiF9juaW9yeMeta?.name ?? "media-hub___it",
    path: indexiF9juaW9yeMeta?.path ?? "/it/media-hub",
    meta: indexiF9juaW9yeMeta || {},
    alias: indexiF9juaW9yeMeta?.alias || [],
    redirect: indexiF9juaW9yeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/index.vue").then(m => m.default || m)
  },
  {
    name: indexiF9juaW9yeMeta?.name ?? "media-hub___zh",
    path: indexiF9juaW9yeMeta?.path ?? "/zh/media-hub",
    meta: indexiF9juaW9yeMeta || {},
    alias: indexiF9juaW9yeMeta?.alias || [],
    redirect: indexiF9juaW9yeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/index.vue").then(m => m.default || m)
  },
  {
    name: loginnpSGPqGqsWMeta?.name ?? "media-hub-login___de",
    path: loginnpSGPqGqsWMeta?.path ?? "/de/media-hub/login",
    meta: loginnpSGPqGqsWMeta || {},
    alias: loginnpSGPqGqsWMeta?.alias || [],
    redirect: loginnpSGPqGqsWMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/login.vue").then(m => m.default || m)
  },
  {
    name: loginnpSGPqGqsWMeta?.name ?? "media-hub-login___en___default",
    path: loginnpSGPqGqsWMeta?.path ?? "/media-hub/login",
    meta: loginnpSGPqGqsWMeta || {},
    alias: loginnpSGPqGqsWMeta?.alias || [],
    redirect: loginnpSGPqGqsWMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/login.vue").then(m => m.default || m)
  },
  {
    name: loginnpSGPqGqsWMeta?.name ?? "media-hub-login___en",
    path: loginnpSGPqGqsWMeta?.path ?? "/en/media-hub/login",
    meta: loginnpSGPqGqsWMeta || {},
    alias: loginnpSGPqGqsWMeta?.alias || [],
    redirect: loginnpSGPqGqsWMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/login.vue").then(m => m.default || m)
  },
  {
    name: loginnpSGPqGqsWMeta?.name ?? "media-hub-login___it",
    path: loginnpSGPqGqsWMeta?.path ?? "/it/media-hub/login",
    meta: loginnpSGPqGqsWMeta || {},
    alias: loginnpSGPqGqsWMeta?.alias || [],
    redirect: loginnpSGPqGqsWMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/login.vue").then(m => m.default || m)
  },
  {
    name: loginnpSGPqGqsWMeta?.name ?? "media-hub-login___zh",
    path: loginnpSGPqGqsWMeta?.path ?? "/zh/media-hub/login",
    meta: loginnpSGPqGqsWMeta || {},
    alias: loginnpSGPqGqsWMeta?.alias || [],
    redirect: loginnpSGPqGqsWMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/media-hub/login.vue").then(m => m.default || m)
  },
  {
    name: _91newsSlug_93cJVf2LgkEMMeta?.name ?? "news-newsSlug___de",
    path: _91newsSlug_93cJVf2LgkEMMeta?.path ?? "/de/nachrichten/:newsSlug",
    meta: _91newsSlug_93cJVf2LgkEMMeta || {},
    alias: _91newsSlug_93cJVf2LgkEMMeta?.alias || [],
    redirect: _91newsSlug_93cJVf2LgkEMMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/news/[newsSlug].vue").then(m => m.default || m)
  },
  {
    name: _91newsSlug_93cJVf2LgkEMMeta?.name ?? "news-newsSlug___en___default",
    path: _91newsSlug_93cJVf2LgkEMMeta?.path ?? "/news/:newsSlug",
    meta: _91newsSlug_93cJVf2LgkEMMeta || {},
    alias: _91newsSlug_93cJVf2LgkEMMeta?.alias || [],
    redirect: _91newsSlug_93cJVf2LgkEMMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/news/[newsSlug].vue").then(m => m.default || m)
  },
  {
    name: _91newsSlug_93cJVf2LgkEMMeta?.name ?? "news-newsSlug___en",
    path: _91newsSlug_93cJVf2LgkEMMeta?.path ?? "/en/news/:newsSlug",
    meta: _91newsSlug_93cJVf2LgkEMMeta || {},
    alias: _91newsSlug_93cJVf2LgkEMMeta?.alias || [],
    redirect: _91newsSlug_93cJVf2LgkEMMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/news/[newsSlug].vue").then(m => m.default || m)
  },
  {
    name: _91newsSlug_93cJVf2LgkEMMeta?.name ?? "news-newsSlug___it",
    path: _91newsSlug_93cJVf2LgkEMMeta?.path ?? "/it/notizie/:newsSlug",
    meta: _91newsSlug_93cJVf2LgkEMMeta || {},
    alias: _91newsSlug_93cJVf2LgkEMMeta?.alias || [],
    redirect: _91newsSlug_93cJVf2LgkEMMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/news/[newsSlug].vue").then(m => m.default || m)
  },
  {
    name: _91newsSlug_93cJVf2LgkEMMeta?.name ?? "news-newsSlug___zh",
    path: _91newsSlug_93cJVf2LgkEMMeta?.path ?? "/zh/xinwen/:newsSlug",
    meta: _91newsSlug_93cJVf2LgkEMMeta || {},
    alias: _91newsSlug_93cJVf2LgkEMMeta?.alias || [],
    redirect: _91newsSlug_93cJVf2LgkEMMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/news/[newsSlug].vue").then(m => m.default || m)
  },
  {
    name: indexYNUcRNvDcqMeta?.name ?? "news___de",
    path: indexYNUcRNvDcqMeta?.path ?? "/de/nachrichten",
    meta: indexYNUcRNvDcqMeta || {},
    alias: indexYNUcRNvDcqMeta?.alias || [],
    redirect: indexYNUcRNvDcqMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexYNUcRNvDcqMeta?.name ?? "news___en___default",
    path: indexYNUcRNvDcqMeta?.path ?? "/news/",
    meta: indexYNUcRNvDcqMeta || {},
    alias: indexYNUcRNvDcqMeta?.alias || [],
    redirect: indexYNUcRNvDcqMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexYNUcRNvDcqMeta?.name ?? "news___en",
    path: indexYNUcRNvDcqMeta?.path ?? "/en/news",
    meta: indexYNUcRNvDcqMeta || {},
    alias: indexYNUcRNvDcqMeta?.alias || [],
    redirect: indexYNUcRNvDcqMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexYNUcRNvDcqMeta?.name ?? "news___it",
    path: indexYNUcRNvDcqMeta?.path ?? "/it/notizie",
    meta: indexYNUcRNvDcqMeta || {},
    alias: indexYNUcRNvDcqMeta?.alias || [],
    redirect: indexYNUcRNvDcqMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexYNUcRNvDcqMeta?.name ?? "news___zh",
    path: indexYNUcRNvDcqMeta?.path ?? "/zh/xinwen",
    meta: indexYNUcRNvDcqMeta || {},
    alias: indexYNUcRNvDcqMeta?.alias || [],
    redirect: indexYNUcRNvDcqMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: successQvKQtrfq78Meta?.name ?? "pardot-success___de",
    path: successQvKQtrfq78Meta?.path ?? "/de/pardot/success",
    meta: successQvKQtrfq78Meta || {},
    alias: successQvKQtrfq78Meta?.alias || [],
    redirect: successQvKQtrfq78Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/pardot/success.vue").then(m => m.default || m)
  },
  {
    name: successQvKQtrfq78Meta?.name ?? "pardot-success___en___default",
    path: successQvKQtrfq78Meta?.path ?? "/pardot/success",
    meta: successQvKQtrfq78Meta || {},
    alias: successQvKQtrfq78Meta?.alias || [],
    redirect: successQvKQtrfq78Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/pardot/success.vue").then(m => m.default || m)
  },
  {
    name: successQvKQtrfq78Meta?.name ?? "pardot-success___en",
    path: successQvKQtrfq78Meta?.path ?? "/en/pardot/success",
    meta: successQvKQtrfq78Meta || {},
    alias: successQvKQtrfq78Meta?.alias || [],
    redirect: successQvKQtrfq78Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/pardot/success.vue").then(m => m.default || m)
  },
  {
    name: successQvKQtrfq78Meta?.name ?? "pardot-success___it",
    path: successQvKQtrfq78Meta?.path ?? "/it/pardot/success",
    meta: successQvKQtrfq78Meta || {},
    alias: successQvKQtrfq78Meta?.alias || [],
    redirect: successQvKQtrfq78Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/pardot/success.vue").then(m => m.default || m)
  },
  {
    name: successQvKQtrfq78Meta?.name ?? "pardot-success___zh",
    path: successQvKQtrfq78Meta?.path ?? "/zh/pardot/success",
    meta: successQvKQtrfq78Meta || {},
    alias: successQvKQtrfq78Meta?.alias || [],
    redirect: successQvKQtrfq78Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/pardot/success.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyFHW5fyzIyIMeta?.name ?? "privacy-policy___de",
    path: privacy_45policyFHW5fyzIyIMeta?.path ?? "/de/privacy-policy",
    meta: privacy_45policyFHW5fyzIyIMeta || {},
    alias: privacy_45policyFHW5fyzIyIMeta?.alias || [],
    redirect: privacy_45policyFHW5fyzIyIMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyFHW5fyzIyIMeta?.name ?? "privacy-policy___en___default",
    path: privacy_45policyFHW5fyzIyIMeta?.path ?? "/privacy-policy/",
    meta: privacy_45policyFHW5fyzIyIMeta || {},
    alias: privacy_45policyFHW5fyzIyIMeta?.alias || [],
    redirect: privacy_45policyFHW5fyzIyIMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyFHW5fyzIyIMeta?.name ?? "privacy-policy___en",
    path: privacy_45policyFHW5fyzIyIMeta?.path ?? "/en/privacy-policy",
    meta: privacy_45policyFHW5fyzIyIMeta || {},
    alias: privacy_45policyFHW5fyzIyIMeta?.alias || [],
    redirect: privacy_45policyFHW5fyzIyIMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyFHW5fyzIyIMeta?.name ?? "privacy-policy___it",
    path: privacy_45policyFHW5fyzIyIMeta?.path ?? "/it/privacy-policy",
    meta: privacy_45policyFHW5fyzIyIMeta || {},
    alias: privacy_45policyFHW5fyzIyIMeta?.alias || [],
    redirect: privacy_45policyFHW5fyzIyIMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyFHW5fyzIyIMeta?.name ?? "privacy-policy___zh",
    path: privacy_45policyFHW5fyzIyIMeta?.path ?? "/zh/privacy-policy",
    meta: privacy_45policyFHW5fyzIyIMeta || {},
    alias: privacy_45policyFHW5fyzIyIMeta?.alias || [],
    redirect: privacy_45policyFHW5fyzIyIMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: _91projectSlug_93MH0lUrzJElMeta?.name ?? "projects-projectSlug___de",
    path: _91projectSlug_93MH0lUrzJElMeta?.path ?? "/de/projekte/:projectSlug",
    meta: _91projectSlug_93MH0lUrzJElMeta || {},
    alias: _91projectSlug_93MH0lUrzJElMeta?.alias || [],
    redirect: _91projectSlug_93MH0lUrzJElMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/projects/[projectSlug].vue").then(m => m.default || m)
  },
  {
    name: _91projectSlug_93MH0lUrzJElMeta?.name ?? "projects-projectSlug___en___default",
    path: _91projectSlug_93MH0lUrzJElMeta?.path ?? "/projects/:projectSlug",
    meta: _91projectSlug_93MH0lUrzJElMeta || {},
    alias: _91projectSlug_93MH0lUrzJElMeta?.alias || [],
    redirect: _91projectSlug_93MH0lUrzJElMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/projects/[projectSlug].vue").then(m => m.default || m)
  },
  {
    name: _91projectSlug_93MH0lUrzJElMeta?.name ?? "projects-projectSlug___en",
    path: _91projectSlug_93MH0lUrzJElMeta?.path ?? "/en/projects/:projectSlug",
    meta: _91projectSlug_93MH0lUrzJElMeta || {},
    alias: _91projectSlug_93MH0lUrzJElMeta?.alias || [],
    redirect: _91projectSlug_93MH0lUrzJElMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/projects/[projectSlug].vue").then(m => m.default || m)
  },
  {
    name: _91projectSlug_93MH0lUrzJElMeta?.name ?? "projects-projectSlug___it",
    path: _91projectSlug_93MH0lUrzJElMeta?.path ?? "/it/progetti/:projectSlug",
    meta: _91projectSlug_93MH0lUrzJElMeta || {},
    alias: _91projectSlug_93MH0lUrzJElMeta?.alias || [],
    redirect: _91projectSlug_93MH0lUrzJElMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/projects/[projectSlug].vue").then(m => m.default || m)
  },
  {
    name: _91projectSlug_93MH0lUrzJElMeta?.name ?? "projects-projectSlug___zh",
    path: _91projectSlug_93MH0lUrzJElMeta?.path ?? "/zh/xiangmu/:projectSlug",
    meta: _91projectSlug_93MH0lUrzJElMeta || {},
    alias: _91projectSlug_93MH0lUrzJElMeta?.alias || [],
    redirect: _91projectSlug_93MH0lUrzJElMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/projects/[projectSlug].vue").then(m => m.default || m)
  },
  {
    name: indexwXmi4oFwK3Meta?.name ?? "projects___de",
    path: indexwXmi4oFwK3Meta?.path ?? "/de/projekte",
    meta: indexwXmi4oFwK3Meta || {},
    alias: indexwXmi4oFwK3Meta?.alias || [],
    redirect: indexwXmi4oFwK3Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: indexwXmi4oFwK3Meta?.name ?? "projects___en___default",
    path: indexwXmi4oFwK3Meta?.path ?? "/projects/",
    meta: indexwXmi4oFwK3Meta || {},
    alias: indexwXmi4oFwK3Meta?.alias || [],
    redirect: indexwXmi4oFwK3Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: indexwXmi4oFwK3Meta?.name ?? "projects___en",
    path: indexwXmi4oFwK3Meta?.path ?? "/en/projects",
    meta: indexwXmi4oFwK3Meta || {},
    alias: indexwXmi4oFwK3Meta?.alias || [],
    redirect: indexwXmi4oFwK3Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: indexwXmi4oFwK3Meta?.name ?? "projects___it",
    path: indexwXmi4oFwK3Meta?.path ?? "/it/progetti",
    meta: indexwXmi4oFwK3Meta || {},
    alias: indexwXmi4oFwK3Meta?.alias || [],
    redirect: indexwXmi4oFwK3Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: indexwXmi4oFwK3Meta?.name ?? "projects___zh",
    path: indexwXmi4oFwK3Meta?.path ?? "/zh/xiangmu",
    meta: indexwXmi4oFwK3Meta || {},
    alias: indexwXmi4oFwK3Meta?.alias || [],
    redirect: indexwXmi4oFwK3Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: indexGrsIIyHQ1LMeta?.name ?? "search___de",
    path: indexGrsIIyHQ1LMeta?.path ?? "/de/suchen",
    meta: indexGrsIIyHQ1LMeta || {},
    alias: indexGrsIIyHQ1LMeta?.alias || [],
    redirect: indexGrsIIyHQ1LMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexGrsIIyHQ1LMeta?.name ?? "search___en___default",
    path: indexGrsIIyHQ1LMeta?.path ?? "/search/",
    meta: indexGrsIIyHQ1LMeta || {},
    alias: indexGrsIIyHQ1LMeta?.alias || [],
    redirect: indexGrsIIyHQ1LMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexGrsIIyHQ1LMeta?.name ?? "search___en",
    path: indexGrsIIyHQ1LMeta?.path ?? "/en/search",
    meta: indexGrsIIyHQ1LMeta || {},
    alias: indexGrsIIyHQ1LMeta?.alias || [],
    redirect: indexGrsIIyHQ1LMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexGrsIIyHQ1LMeta?.name ?? "search___it",
    path: indexGrsIIyHQ1LMeta?.path ?? "/it/ricerca",
    meta: indexGrsIIyHQ1LMeta || {},
    alias: indexGrsIIyHQ1LMeta?.alias || [],
    redirect: indexGrsIIyHQ1LMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexGrsIIyHQ1LMeta?.name ?? "search___zh",
    path: indexGrsIIyHQ1LMeta?.path ?? "/zh/sousuo",
    meta: indexGrsIIyHQ1LMeta || {},
    alias: indexGrsIIyHQ1LMeta?.alias || [],
    redirect: indexGrsIIyHQ1LMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexyI1RtRHRMeMeta?.name ?? "sectors-sectorSlug___de",
    path: indexyI1RtRHRMeMeta?.path ?? "/de/sektoren/:sectorSlug",
    meta: indexyI1RtRHRMeMeta || {},
    alias: indexyI1RtRHRMeMeta?.alias || [],
    redirect: indexyI1RtRHRMeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/[sectorSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexyI1RtRHRMeMeta?.name ?? "sectors-sectorSlug___en___default",
    path: indexyI1RtRHRMeMeta?.path ?? "/sectors/:sectorSlug/",
    meta: indexyI1RtRHRMeMeta || {},
    alias: indexyI1RtRHRMeMeta?.alias || [],
    redirect: indexyI1RtRHRMeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/[sectorSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexyI1RtRHRMeMeta?.name ?? "sectors-sectorSlug___en",
    path: indexyI1RtRHRMeMeta?.path ?? "/en/sectors/:sectorSlug",
    meta: indexyI1RtRHRMeMeta || {},
    alias: indexyI1RtRHRMeMeta?.alias || [],
    redirect: indexyI1RtRHRMeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/[sectorSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexyI1RtRHRMeMeta?.name ?? "sectors-sectorSlug___it",
    path: indexyI1RtRHRMeMeta?.path ?? "/it/settori/:sectorSlug",
    meta: indexyI1RtRHRMeMeta || {},
    alias: indexyI1RtRHRMeMeta?.alias || [],
    redirect: indexyI1RtRHRMeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/[sectorSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexyI1RtRHRMeMeta?.name ?? "sectors-sectorSlug___zh",
    path: indexyI1RtRHRMeMeta?.path ?? "/zh/bumen/:sectorSlug",
    meta: indexyI1RtRHRMeMeta || {},
    alias: indexyI1RtRHRMeMeta?.alias || [],
    redirect: indexyI1RtRHRMeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/[sectorSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: portfolioNcqfFg8NHxMeta?.name ?? "sectors-sectorSlug-portfolio___de",
    path: portfolioNcqfFg8NHxMeta?.path ?? "/de/sektoren/:sectorSlug/portfolio",
    meta: portfolioNcqfFg8NHxMeta || {},
    alias: portfolioNcqfFg8NHxMeta?.alias || [],
    redirect: portfolioNcqfFg8NHxMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/[sectorSlug]/portfolio.vue").then(m => m.default || m)
  },
  {
    name: portfolioNcqfFg8NHxMeta?.name ?? "sectors-sectorSlug-portfolio___en___default",
    path: portfolioNcqfFg8NHxMeta?.path ?? "/sectors/:sectorSlug/portfolio",
    meta: portfolioNcqfFg8NHxMeta || {},
    alias: portfolioNcqfFg8NHxMeta?.alias || [],
    redirect: portfolioNcqfFg8NHxMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/[sectorSlug]/portfolio.vue").then(m => m.default || m)
  },
  {
    name: portfolioNcqfFg8NHxMeta?.name ?? "sectors-sectorSlug-portfolio___en",
    path: portfolioNcqfFg8NHxMeta?.path ?? "/en/sectors/:sectorSlug/portfolio",
    meta: portfolioNcqfFg8NHxMeta || {},
    alias: portfolioNcqfFg8NHxMeta?.alias || [],
    redirect: portfolioNcqfFg8NHxMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/[sectorSlug]/portfolio.vue").then(m => m.default || m)
  },
  {
    name: portfolioNcqfFg8NHxMeta?.name ?? "sectors-sectorSlug-portfolio___it",
    path: portfolioNcqfFg8NHxMeta?.path ?? "/it/settori/:sectorSlug/portfolio",
    meta: portfolioNcqfFg8NHxMeta || {},
    alias: portfolioNcqfFg8NHxMeta?.alias || [],
    redirect: portfolioNcqfFg8NHxMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/[sectorSlug]/portfolio.vue").then(m => m.default || m)
  },
  {
    name: portfolioNcqfFg8NHxMeta?.name ?? "sectors-sectorSlug-portfolio___zh",
    path: portfolioNcqfFg8NHxMeta?.path ?? "/zh/bumen/:sectorSlug/wenjian-jia",
    meta: portfolioNcqfFg8NHxMeta || {},
    alias: portfolioNcqfFg8NHxMeta?.alias || [],
    redirect: portfolioNcqfFg8NHxMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/[sectorSlug]/portfolio.vue").then(m => m.default || m)
  },
  {
    name: index7uxvHB9tBdMeta?.name ?? "sectors___de",
    path: index7uxvHB9tBdMeta?.path ?? "/de/sektoren",
    meta: index7uxvHB9tBdMeta || {},
    alias: index7uxvHB9tBdMeta?.alias || [],
    redirect: index7uxvHB9tBdMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/index.vue").then(m => m.default || m)
  },
  {
    name: index7uxvHB9tBdMeta?.name ?? "sectors___en___default",
    path: index7uxvHB9tBdMeta?.path ?? "/sectors/",
    meta: index7uxvHB9tBdMeta || {},
    alias: index7uxvHB9tBdMeta?.alias || [],
    redirect: index7uxvHB9tBdMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/index.vue").then(m => m.default || m)
  },
  {
    name: index7uxvHB9tBdMeta?.name ?? "sectors___en",
    path: index7uxvHB9tBdMeta?.path ?? "/en/sectors",
    meta: index7uxvHB9tBdMeta || {},
    alias: index7uxvHB9tBdMeta?.alias || [],
    redirect: index7uxvHB9tBdMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/index.vue").then(m => m.default || m)
  },
  {
    name: index7uxvHB9tBdMeta?.name ?? "sectors___it",
    path: index7uxvHB9tBdMeta?.path ?? "/it/settori",
    meta: index7uxvHB9tBdMeta || {},
    alias: index7uxvHB9tBdMeta?.alias || [],
    redirect: index7uxvHB9tBdMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/index.vue").then(m => m.default || m)
  },
  {
    name: index7uxvHB9tBdMeta?.name ?? "sectors___zh",
    path: index7uxvHB9tBdMeta?.path ?? "/zh/bumen",
    meta: index7uxvHB9tBdMeta || {},
    alias: index7uxvHB9tBdMeta?.alias || [],
    redirect: index7uxvHB9tBdMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/sectors/index.vue").then(m => m.default || m)
  },
  {
    name: _91serviceSlug_93piRIjeJxAzMeta?.name ?? "services-serviceSlug___de",
    path: _91serviceSlug_93piRIjeJxAzMeta?.path ?? "/de/dienstleistungen/:serviceSlug",
    meta: _91serviceSlug_93piRIjeJxAzMeta || {},
    alias: _91serviceSlug_93piRIjeJxAzMeta?.alias || [],
    redirect: _91serviceSlug_93piRIjeJxAzMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/services/[serviceSlug].vue").then(m => m.default || m)
  },
  {
    name: _91serviceSlug_93piRIjeJxAzMeta?.name ?? "services-serviceSlug___en___default",
    path: _91serviceSlug_93piRIjeJxAzMeta?.path ?? "/services/:serviceSlug",
    meta: _91serviceSlug_93piRIjeJxAzMeta || {},
    alias: _91serviceSlug_93piRIjeJxAzMeta?.alias || [],
    redirect: _91serviceSlug_93piRIjeJxAzMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/services/[serviceSlug].vue").then(m => m.default || m)
  },
  {
    name: _91serviceSlug_93piRIjeJxAzMeta?.name ?? "services-serviceSlug___en",
    path: _91serviceSlug_93piRIjeJxAzMeta?.path ?? "/en/services/:serviceSlug",
    meta: _91serviceSlug_93piRIjeJxAzMeta || {},
    alias: _91serviceSlug_93piRIjeJxAzMeta?.alias || [],
    redirect: _91serviceSlug_93piRIjeJxAzMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/services/[serviceSlug].vue").then(m => m.default || m)
  },
  {
    name: _91serviceSlug_93piRIjeJxAzMeta?.name ?? "services-serviceSlug___it",
    path: _91serviceSlug_93piRIjeJxAzMeta?.path ?? "/it/servizi/:serviceSlug",
    meta: _91serviceSlug_93piRIjeJxAzMeta || {},
    alias: _91serviceSlug_93piRIjeJxAzMeta?.alias || [],
    redirect: _91serviceSlug_93piRIjeJxAzMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/services/[serviceSlug].vue").then(m => m.default || m)
  },
  {
    name: _91serviceSlug_93piRIjeJxAzMeta?.name ?? "services-serviceSlug___zh",
    path: _91serviceSlug_93piRIjeJxAzMeta?.path ?? "/zh/fuwu/:serviceSlug",
    meta: _91serviceSlug_93piRIjeJxAzMeta || {},
    alias: _91serviceSlug_93piRIjeJxAzMeta?.alias || [],
    redirect: _91serviceSlug_93piRIjeJxAzMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/services/[serviceSlug].vue").then(m => m.default || m)
  },
  {
    name: indexb3TtlJztXqMeta?.name ?? "services___de",
    path: indexb3TtlJztXqMeta?.path ?? "/de/dienstleistungen",
    meta: indexb3TtlJztXqMeta || {},
    alias: indexb3TtlJztXqMeta?.alias || [],
    redirect: indexb3TtlJztXqMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexb3TtlJztXqMeta?.name ?? "services___en___default",
    path: indexb3TtlJztXqMeta?.path ?? "/services/",
    meta: indexb3TtlJztXqMeta || {},
    alias: indexb3TtlJztXqMeta?.alias || [],
    redirect: indexb3TtlJztXqMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexb3TtlJztXqMeta?.name ?? "services___en",
    path: indexb3TtlJztXqMeta?.path ?? "/en/services",
    meta: indexb3TtlJztXqMeta || {},
    alias: indexb3TtlJztXqMeta?.alias || [],
    redirect: indexb3TtlJztXqMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexb3TtlJztXqMeta?.name ?? "services___it",
    path: indexb3TtlJztXqMeta?.path ?? "/it/servizi",
    meta: indexb3TtlJztXqMeta || {},
    alias: indexb3TtlJztXqMeta?.alias || [],
    redirect: indexb3TtlJztXqMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexb3TtlJztXqMeta?.name ?? "services___zh",
    path: indexb3TtlJztXqMeta?.path ?? "/zh/fuwu",
    meta: indexb3TtlJztXqMeta || {},
    alias: indexb3TtlJztXqMeta?.alias || [],
    redirect: indexb3TtlJztXqMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexh1GmYsLMjyMeta?.name ?? "whistleblowing___de",
    path: indexh1GmYsLMjyMeta?.path ?? "/de/whistleblowing",
    meta: indexh1GmYsLMjyMeta || {},
    alias: indexh1GmYsLMjyMeta?.alias || [],
    redirect: indexh1GmYsLMjyMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/whistleblowing/index.vue").then(m => m.default || m)
  },
  {
    name: indexh1GmYsLMjyMeta?.name ?? "whistleblowing___en___default",
    path: indexh1GmYsLMjyMeta?.path ?? "/whistleblowing/",
    meta: indexh1GmYsLMjyMeta || {},
    alias: indexh1GmYsLMjyMeta?.alias || [],
    redirect: indexh1GmYsLMjyMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/whistleblowing/index.vue").then(m => m.default || m)
  },
  {
    name: indexh1GmYsLMjyMeta?.name ?? "whistleblowing___en",
    path: indexh1GmYsLMjyMeta?.path ?? "/en/whistleblowing",
    meta: indexh1GmYsLMjyMeta || {},
    alias: indexh1GmYsLMjyMeta?.alias || [],
    redirect: indexh1GmYsLMjyMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/whistleblowing/index.vue").then(m => m.default || m)
  },
  {
    name: indexh1GmYsLMjyMeta?.name ?? "whistleblowing___it",
    path: indexh1GmYsLMjyMeta?.path ?? "/it/whistleblowing",
    meta: indexh1GmYsLMjyMeta || {},
    alias: indexh1GmYsLMjyMeta?.alias || [],
    redirect: indexh1GmYsLMjyMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/whistleblowing/index.vue").then(m => m.default || m)
  },
  {
    name: indexh1GmYsLMjyMeta?.name ?? "whistleblowing___zh",
    path: indexh1GmYsLMjyMeta?.path ?? "/zh/whistleblowing",
    meta: indexh1GmYsLMjyMeta || {},
    alias: indexh1GmYsLMjyMeta?.alias || [],
    redirect: indexh1GmYsLMjyMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/pages/whistleblowing/index.vue").then(m => m.default || m)
  },
  {
    name: pininfarinaz5JivmXIxaMeta?.name ?? undefined,
    path: pininfarinaz5JivmXIxaMeta?.path ?? "/sitemap.xml",
    meta: pininfarinaz5JivmXIxaMeta || {},
    alias: pininfarinaz5JivmXIxaMeta?.alias || [],
    redirect: pininfarinaz5JivmXIxaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250625182455/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  }
]